module.exports = __webpack_public_path__ + "static/media/offer-deal-bg.bfcbb3fa.jpg";